// extracted by mini-css-extract-plugin
export default {"knowledge":"Knowledge_knowledge__jWIe9","knowledgeLeft":"Knowledge_knowledgeLeft__UCxTt","knowledgeRight":"Knowledge_knowledgeRight__WHEd3","button":"Knowledge_button__Clj-f"};